import { router } from "@inertiajs/react";
import type { DomainJourneys } from "@/types";

type Props = {
  domainId: string;
  journeys: DomainJourneys;
  onWatchMapping?: (interactionId: string) => void;
};

export default function JourneysMappingFailed({ domainId, journeys, onWatchMapping }: Props) {
  const retry = () => {
    if (!journeys.can_retry) {
      return;
    }

    router.post(`/domains/${domainId}/journey_mapping`, {}, { preserveScroll: true });
  };

  return (
    <div className="mt-6 space-y-4">
      <div className="rounded-lg border border-error/20 bg-error/5 px-4 py-4">
        <p className="font-medium text-error">We couldn’t map signed-in journeys</p>
        <p className="mt-1 text-sm leading-relaxed text-gray-600">
          Mapping finished without jobs we can list. Watch the mapping session to see what happened — login may have
          failed.
        </p>
        {journeys.manual_create_hint ? (
          <p className="mt-2 text-sm text-gray-600">{journeys.manual_create_hint}</p>
        ) : null}
      </div>

      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        {journeys.mapping_interaction_id ? (
          <button
            type="button"
            className="cursor-pointer text-sm font-medium text-primary hover:underline"
            onClick={() => {
              if (journeys.mapping_interaction_id) {
                onWatchMapping?.(journeys.mapping_interaction_id);
              }
            }}
          >
            Watch mapping session
          </button>
        ) : null}
        {journeys.can_retry ? (
          <button type="button" className="btn btn-primary" onClick={retry}>
            Retry mapping
          </button>
        ) : null}
      </div>
    </div>
  );
}
